import React from 'react'
import { Grid, Spacer, Text, useMediaQuery } from '@geist-ui/react'

import Signup from '../Signup'

export default function Login() {
  const isMD = useMediaQuery('md', { match: 'up' })
  const isLG = useMediaQuery('lg', { match: 'up' })

  const form = isMD ? (
    <>
      <Grid
        xs={24}
        style={{
          height: '34px',
        }}
      />
      <Grid
        direction="column"
        xs={0}
        md={11}
        style={{
          paddingRight: '5px',
          paddingTop: '37px',
        }}
      >
        <div>
          <Text h1 font="32px" style={{ color: '#004080', lineHeight: '1.1' }}>
            Leaks Happen. Be Protected.℠
          </Text>
          <Text
            p
            font="26px"
            style={{
              lineHeight: '1.5',
              marginBottom: 0,
              marginTop: 0,
              paddingRight: '19px',
            }}
          >
            Leaks happen more often than you think, and they can lead to
            unexpected and costly water bills that most homeowners’ insurance
            won’t cover.
          </Text>
          <Text
            p
            font="26px"
            style={{
              lineHeight: '1.5',
              marginBottom: 0,
              marginTop: 0,
              paddingRight: '19px',
            }}
          >
            <a
              href="https://louisvillewater.com"
              target="_blank"
              rel="noopener"
              style={{ color: '#004080' }}
            >
              Louisville Water
            </a>{' '}
            developed WaterPro Water Leak Protection Plan<sup style={{ fontSize: '10px' }}>SM</sup> to fill
            this gap, offering a simple, affordable solution that covers you
            from the cost of water you didn’t use.
          </Text>
        </div>
        <div>
          <Grid
            style={{
              backgroundColor: 'rgb(87, 179, 228)',
              borderRadius: '35px',
              padding: '10px 15px 10px 15px',
              marginTop: '18px',
            }}
          >
            <Text
              h3
              b
              font="28px"
              style={{
                color: 'white',
                lineHeight: '28.9px',
                marginBottom: 0,
                textAlign: 'center',
              }}
            >
              Up to $3,000 coverage •{' '}
              <span style={{ display: 'inline-block' }}>Only $3 per month</span>
            </Text>
          </Grid>
        </div>
        <div>
          <Text
            p
            font="26px"
            style={{
              lineHeight: '1.5',
              marginTop: '18px',
              paddingRight: '19px',
            }}
          >
            Get peace of mind—Enroll in WaterPro today!
          </Text>
          <Text p font="16px" style={{ marginTop: '10px', color: '#4b5563' }}>
            If eligible, coverage is added to your Louisville Water bill.
          </Text>
          <Text p font="14px" style={{ color: '#6b7280', marginTop: '6px' }}>
            Brought to you by Louisville Water
          </Text>
        </div>
      </Grid>

      <Grid
        xs={0}
        md={12}
        style={{
          backgroundColor: 'rgb(0, 64, 128)',
          borderRadius: '10px',
          color: 'white',
          padding: isLG ? '31px' : 'calc((100vw - 180px) * 0.025)',
          zIndex: 10,
        }}
      >
        <Signup />
      </Grid>
    </>
  ) : (
    <Grid direction="column" xs={24} md={0}>
      <Text
        h1
        font="24px"
        style={{ color: '#004080', lineHeight: '1.1', textAlign: 'center' }}
      >
        Leaks Happen. Be Protected.℠
      </Text>
      <Text
        p
        font="18px"
        style={{
          lineHeight: '1.5',
          marginBottom: 0,
          marginTop: 0,
          textAlign: 'center',
        }}
      >
        Leaks happen more often than you think, and they can lead to unexpected
        and costly water bills that most homeowners’ insurance won’t cover.
      </Text>
      <Text
        p
        font="18px"
        style={{
          lineHeight: '1.5',
          marginBottom: 0,
          marginTop: 0,
          textAlign: 'center',
        }}
      >
        <a href="https://louisvillewater.com/" target="_blank" rel="noopener" style={{ color: '#004080' }}>
          Louisville Water
        </a>{' '}
        developed WaterPro Water Leak Protection Plan<sup style={{ fontSize: '10px' }}>SM</sup> to fill this
        gap, offering a simple, affordable solution that covers you from the cost of water you didn’t use.
      </Text>
      <Text
        p
        font="18px"
        style={{
          lineHeight: '1.5',
          marginBottom: 0,
          marginTop: 0,
          textAlign: 'center',
        }}
      >
        Get peace of mind—Enroll in WaterPro today!
      </Text>
      <Text p font="14px" style={{ marginTop: '10px', color: '#4b5563', textAlign: 'center' }}>
        If eligible, coverage is added to your Louisville Water bill.
      </Text>
      <Text p font="13px" style={{ color: '#6b7280', marginTop: '6px', textAlign: 'center' }}>
        Brought to you by Louisville Water
      </Text>
      <Spacer h={1} />
      <div
        style={{
          backgroundColor: 'rgb(0, 64, 128)',
          borderRadius: '10px',
          color: 'white',
          padding: 'calc(100vw * 0.06)',
          zIndex: 10,
        }}
      >
        <Signup />
      </div>
    </Grid>
  )

  return form
}
